module.exports = __webpack_public_path__ + "img/home.87fed232.svg";